import { PageHead } from "@generalapplications/html-render/react";
import { PageHero } from "@/app/common/components/composite/layout/PageHero";
import { PageSection } from "@/app/common/components/composite/layout/PageSection";
import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { SummaryCard } from "@/app/common/components/composite/list/SummaryCard";
import { industries, industriesIndexPage } from "@/content/industries";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { Grid, PageArticle } from "@generalapplications/ui";

export function IndustriesPage() {
  const head = pageHead({
    path: routes.industries.index,
    title: industriesIndexPage.seoTitle,
    description: industriesIndexPage.seoDescription,
    imagePath: industriesIndexPage.image,
  });

  return (
    <PageArticle rhythm="xl">
      <PageHead head={head} />
      <PageHero
        headline={industriesIndexPage.headline}
        copy={industriesIndexPage.heroCopy}
        image={industriesIndexPage.image}
      />

      <PageSection
        title={industriesIndexPage.introTitle}
        body={industriesIndexPage.introCopy}
      />

      <RevealGroup>
        <Grid columns={{ base: 1, md: 2, lg: 3 }} gap="xl">
          {industries.map((industry) => (
            <RevealItem key={industry.slug}>
              <SummaryCard
                title={industry.title}
                summary={industry.summary}
                href={routes.industries.detail(industry.slug)}
              />
            </RevealItem>
          ))}
        </Grid>
      </RevealGroup>
    </PageArticle>
  );
}
